import React from 'react';
import { inject, observer } from "mobx-react";

export default inject('igStore')(observer(({igStore, height}) => {
  const { reveal, tab, toggleReveal, game } = igStore;
  if (!/events|stats/.test(tab)) return null;
  if (height < 130) return <div className={`ig-reveal s-c-${game.sid}`}/>;
  return <button
    className={`ig-reveal s-c-${game.sid}${reveal ? ` ig-reveal--active` : ''}`}
    onClick={toggleReveal}>
    <i className="f-s-ico-arrow_buttom_1"/>
  </button>;
}))


// WEBPACK FOOTER //
// ./src/components/ig/revealBtn.js